import { apiUrlAws } from "@settings";
import { getBaseAxiosInstance } from "./base";

const BASE_URL = apiUrlAws;

export default getBaseAxiosInstance(BASE_URL);
